import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "admin-wrapper"
};
import { RouterView } from 'vue-router';

import { useApiEventHandler, useApiForbiddenHandler } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/hooks/auto-import.js';
export default {
  __name: 'app-page',
  setup(__props) {
    useApiEventHandler(true);
    useApiForbiddenHandler();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(RouterView), null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
        _: 1
      })]);
    };
  }
};